import { render, staticRenderFns } from "./NumberFormat.vue?vue&type=template&id=508c10de&scoped=true&"
import script from "./NumberFormat.vue?vue&type=script&lang=js&"
export * from "./NumberFormat.vue?vue&type=script&lang=js&"
import style0 from "./NumberFormat.vue?vue&type=style&index=0&id=508c10de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508c10de",
  null
  
)

export default component.exports